import * as React from "react";
import type { SVGProps } from "react";
const SvgGlasses01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M9.12 12h-1a2.36 2.36 0 0 1-2.36 2.36v2A4.36 4.36 0 0 0 10.12 12zm-3.36 3.36v-1A2.36 2.36 0 0 1 3.4 12h-2a4.36 4.36 0 0 0 4.36 4.36zM2.4 12h1a2.36 2.36 0 0 1 2.36-2.36v-2A4.36 4.36 0 0 0 1.4 12zm3.36-3.36v1A2.36 2.36 0 0 1 8.12 12h2a4.36 4.36 0 0 0-4.36-4.36zm3.33 2.64.865.5A2.36 2.36 0 0 1 12 10.6v-2a4.36 4.36 0 0 0-3.776 2.18zM12 9.6v1c.872 0 1.635.473 2.045 1.18l.866-.5.865-.5A4.36 4.36 0 0 0 12 8.6zm9.6 2.4h-1a2.36 2.36 0 0 1-2.36 2.36v2A4.36 4.36 0 0 0 22.6 12zm-3.36 3.36v-1A2.36 2.36 0 0 1 15.88 12h-2a4.36 4.36 0 0 0 4.36 4.36zM14.88 12h1a2.36 2.36 0 0 1 2.36-2.36v-2A4.36 4.36 0 0 0 13.88 12zm3.36-3.36v1A2.36 2.36 0 0 1 20.6 12h2a4.36 4.36 0 0 0-4.36-4.36z"
    />
  </svg>
);
export default SvgGlasses01;
